<template>
  <q-dialog v-model="shown">
    <q-card
      :style="{ 'width': '450px', 'max-width': '95%' }"
      @keyup.enter="emitOrderItem"
    >
      <q-card-section
        class="text-h5"
      >
        Gift Card Amount
      </q-card-section>

      <q-card-section class="row justify-evenly items-center">
        <q-input
          ref="amount"
          v-model.number="amount"
          label="Card Amount"
          :prefix="currentCircuit.localeCurrencySymbol"
          type="number"
          step="0.01"
          :rules="[
            val => val > 0 || 'Cannot be zero',
            val => val !== null && val !== '' || 'Cannot be blank'
          ]"
        />
      </q-card-section>

      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Cancel"
          :outline="true"
        />
        <q-btn
          v-close-popup
          label="Assign Card"
          color="primary"
          @click="emitOrderItem"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'RegisterButtonGiftCardDialog',
  configuration: ['currentCircuit'],
  emits: ['update-gift-card'],
  data () {
    return {
      shown: false,
      orderItem: null,
      amount: 0
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.orderItem = null
        this.amount = 0
      }
    }
  },
  methods: {
    async show (orderItem) {
      this.orderItem = orderItem
      this.amount = 20

      this.shown = true

      await this.$nextTick() // Wait for elements to be rendered
      this.$refs.amount.select()
    },
    emitOrderItem () {
      if (this.amount > 0) {
        this.orderItem.giftCard.initialValue = this.amount
        this.orderItem.price = this.amount
      }
      this.$emit('update-gift-card', this.orderItem)
      this.shown = false
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  flex-wrap: wrap;
}
.button {
  padding: 10px;
  height: 100%;
}
</style>
